const CHART_WIDTH = 900;
const CHART_HEIGHT = 400;
const CONSUMED_COLOR = "#1ba08e";
const GENERATED_COLOR = "#ff9c07";

function formatAxisDate(dateStr) {
  if (!dateStr) return "";
  const parts = String(dateStr).split(" ")[0].split("-");
  if (parts.length === 3) return `${parts[2]}/${parts[1]}`;
  return String(dateStr).slice(0, 10);
}

export function renderDailyEnergyChartImage(dailySeries) {
  const canvas = document.createElement("canvas");
  canvas.width = CHART_WIDTH;
  canvas.height = CHART_HEIGHT;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, CHART_WIDTH, CHART_HEIGHT);

  if (!dailySeries?.length) {
    ctx.fillStyle = "#64748b";
    ctx.font = "16px Helvetica, Arial, sans-serif";
    ctx.textAlign = "center";
    ctx.fillText(
      "No daily energy data for the selected range.",
      CHART_WIDTH / 2,
      CHART_HEIGHT / 2,
    );
    return canvas.toDataURL("image/png");
  }

  const margin = { top: 24, right: 24, bottom: 56, left: 56 };
  const plotWidth = CHART_WIDTH - margin.left - margin.right;
  const plotHeight = CHART_HEIGHT - margin.top - margin.bottom;

  const maxValue = Math.max(
    1,
    ...dailySeries.flatMap((point) => [point.consumed, point.generated]),
  );

  const groupWidth = plotWidth / dailySeries.length;
  const barWidth = Math.min(18, groupWidth * 0.32);

  ctx.strokeStyle = "#e2e8f0";
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(margin.left, margin.top);
  ctx.lineTo(margin.left, margin.top + plotHeight);
  ctx.lineTo(margin.left + plotWidth, margin.top + plotHeight);
  ctx.stroke();

  for (let tick = 0; tick <= 4; tick += 1) {
    const value = (maxValue / 4) * tick;
    const y = margin.top + plotHeight - (value / maxValue) * plotHeight;
    ctx.strokeStyle = "#f1f5f9";
    ctx.beginPath();
    ctx.moveTo(margin.left, y);
    ctx.lineTo(margin.left + plotWidth, y);
    ctx.stroke();

    ctx.fillStyle = "#64748b";
    ctx.font = "11px Helvetica, Arial, sans-serif";
    ctx.textAlign = "right";
    ctx.fillText(value.toFixed(0), margin.left - 8, y + 4);
  }

  dailySeries.forEach((point, index) => {
    const groupCenter =
      margin.left + groupWidth * index + groupWidth / 2;

    const consumedHeight = (point.consumed / maxValue) * plotHeight;
    const generatedHeight = (point.generated / maxValue) * plotHeight;

    ctx.fillStyle = CONSUMED_COLOR;
    ctx.fillRect(
      groupCenter - barWidth - 2,
      margin.top + plotHeight - consumedHeight,
      barWidth,
      consumedHeight,
    );

    ctx.fillStyle = GENERATED_COLOR;
    ctx.fillRect(
      groupCenter + 2,
      margin.top + plotHeight - generatedHeight,
      barWidth,
      generatedHeight,
    );

    if (dailySeries.length <= 20 || index % Math.ceil(dailySeries.length / 12) === 0) {
      ctx.fillStyle = "#64748b";
      ctx.font = "10px Helvetica, Arial, sans-serif";
      ctx.textAlign = "center";
      ctx.fillText(
        formatAxisDate(point.date),
        groupCenter,
        margin.top + plotHeight + 16,
      );
    }
  });

  ctx.font = "12px Helvetica, Arial, sans-serif";
  ctx.textAlign = "left";
  ctx.fillStyle = CONSUMED_COLOR;
  ctx.fillRect(margin.left + 4, 8, 12, 12);
  ctx.fillStyle = "#1e293b";
  ctx.fillText("Consumed (kWh)", margin.left + 20, 18);

  ctx.fillStyle = GENERATED_COLOR;
  ctx.fillRect(margin.left + 130, 8, 12, 12);
  ctx.fillStyle = "#1e293b";
  ctx.fillText("Generated (kWh)", margin.left + 146, 18);

  ctx.save();
  ctx.translate(16, margin.top + plotHeight / 2);
  ctx.rotate(-Math.PI / 2);
  ctx.fillStyle = "#475569";
  ctx.font = "11px Helvetica, Arial, sans-serif";
  ctx.textAlign = "center";
  ctx.fillText("kWh", 0, 0);
  ctx.restore();

  return canvas.toDataURL("image/png");
}
